import Breadcrumbs from "../components/Breadcrumbs";
import { EmailLink } from "../components/ContactInfo";

export default function AffiliateDisclosure() {
  return (
    <div className="max-w-3xl mx-auto px-5 lg:px-8 py-14" data-testid="affiliate-page">
      <Breadcrumbs items={[{ label: "Affiliate Disclosure" }]} />
      <h1 className="font-playfair text-4xl sm:text-5xl text-neutral-900 tracking-tight leading-[1.05] mb-6">
        Affiliate disclosure
      </h1>
      <div className="editorial-prose">
        <p>
          Some links on SaaSRadarHub may be affiliate links. This means we may
          receive a commission if you purchase or sign up through certain
          links, at no additional cost to you.
        </p>
        <p>
          Our recommendations are based on our assessment of the software and
          its usefulness for particular users. Affiliate relationships do not
          automatically determine editorial recommendations.
        </p>
        <h2>How we handle affiliate relationships</h2>
        <p>
          When possible, we clearly mark affiliate links or sections. We only
          participate in affiliate programs for products we believe are
          credible choices for the audiences we describe.
        </p>
        <p>
          If you have questions about any specific recommendation or want to
          flag a correction, email us at{" "}
          <EmailLink testid="affiliate-page-email" />.
        </p>
        <h2>Affiliate programs and partnerships</h2>
        <p>
          SaaS companies and affiliate program managers can contact us at{" "}
          <EmailLink subject="Affiliate program inquiry" testid="affiliate-page-partner-email" />.
          Any partnership is disclosed and never determines our editorial recommendations.
        </p>
      </div>
    </div>
  );
}
